import {
  BaseElementWidget,
  CustomWidget,
  SPI,
  ViewType
} from '@kunlun/dependencies';
import BillingBillDetailPage from '../../components/BillingBillDetailPage.vue';

/**
 * 经销商开票单详情页 - 完全自定义 Widget
 * 替换 Oinone 默认 Form 视图
 */
@SPI.ClassFactory(
  BaseElementWidget.Token({
    viewType: ViewType.Form,
    widget: ['BillingBillDetailPage']
  })
)
export class BillingBillDetailWidget extends CustomWidget {
  public initialize(props: any) {
    super.initialize(props);
    this.setComponent(BillingBillDetailPage);
    return this;
  }
}
